<template>
  <el-dialog
    title="设备报警信息"
    :visible.sync="dialogTableVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="920px"
  >
    <el-table :data="responseData.list" height="500px">
      <el-table-column label="序号" width="70" align="center">
        <template v-slot="scope">
          {{
            responseData.pageSize * (responseData.pageNum - 1) +
              scope.$index +
              1
          }}
        </template>
      </el-table-column>
      <el-table-column
        property="deviceId"
        label="设备序列号"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        property="deviceType"
        label="设备类型"
         align="center"
      ></el-table-column>
      <el-table-column property="deviceName" label="设备名称" align="center"></el-table-column>
      <el-table-column property="endPointType" label="部件类型" align="center"></el-table-column>
      <el-table-column property="msg" label="报警消息" align="center" width="200"></el-table-column>
      <el-table-column property="time" label="报警时间" width="100" align="center"></el-table-column>
      <el-table-column property="status" label="状态" width="100" align="center">
        <template v-slot="scope">
          <el-tag type="success" v-if="scope.row.status == 1">已处理</el-tag>
          <el-tag type="info" v-if="scope.row.status == 2">误报</el-tag>
          <el-tag type="danger" v-if="scope.row.status == 3">未处理</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template v-slot="scope">
          <div v-if="scope.row.status != 3">
            <el-button type="info" plain size="mini" @click="getDetail(scope.row)">详情</el-button>
          </div>
          <div v-if="scope.row.status == 3" style="padding-bottom:5px;">
            <el-button type="primary" plain size="mini" @click="handle(scope.row,1)">处理</el-button>
          </div>
          <div v-if="scope.row.status == 3">
            <el-button type="info" plain size="mini" @click="handle(scope.row,2)">误报</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_box">
      <el-pagination
        v-if="responseData.total > 0"
        @current-change="handleCurrentChange"
        :current-page="requestData.pageNum"
        :page-size="requestData.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="responseData.total"
      >
      </el-pagination>
    </div>
    <handle-dialod :handleResize="handleResize" :info="info" :status="status" @getList="getList"></handle-dialod>
    <info-dialod :infoResize="infoResize" :info="info"></info-dialod>
  </el-dialog>
</template>

<script>
import HandleDialod from "./ProtectDeviceManagementInfoHandle"
import InfoDialod from "./ProtectDeviceManagementInfoDialog"
export default {
  name: "ProtectDeviceManagementInfo",
  components: {
    HandleDialod,
    InfoDialod
  },
  props: {
    alertResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      requestData: {
        pageSize: 20,
        pageNum: 1,
        hostId: "",
        loopId: "",
        partId: ""
      },
      responseData: {
        total: 0,
        list: []
      },
      info: {},
      handleResize: 0,
      status: 0,
      infoResize: 0
    };
  },
  created() {},
  mounted() {},
  watch: {
    alertResize: function(newVal, oldVal) {
      if (newVal) {
        this.requestData.hostId = this.detail.hostId;
        this.requestData.loopId = this.detail.loopId;
        this.requestData.partId = this.detail.partId;
        this.getList();
        this.dialogTableVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getList();
    },
    async getList() {
      let res = await this.$Http.getSafeEquipmentAlert(this.requestData);
      if (res.code == 200) {
        this.responseData = res.data;
        this.responseData.list = res.data.list || [];
        this.responseData.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.responseData.list = [];
        this.responseData.total = 0;
      } else {
        this.responseData.list = [];
        this.responseData.total = 0;
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    getDetail(row) {
      this.info = row;
      this.infoResize++;
    },
    handle(row,num) {
      this.info = row;
      this.status = num;
      this.handleResize++;
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination_box {
  // width: 100%;
  // height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
